
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.143 5H6.429A1.43 1.43 0 005 6.429v5.714c0 .788.64 1.428 1.429 1.428h5.714a1.43 1.43 0 001.428-1.428V6.429A1.43 1.43 0 0012.143 5zm-1.429 5.714H7.857V7.857h2.857v2.857zM23.572 5h-5.715a1.43 1.43 0 00-1.428 1.429v5.714c0 .788.64 1.428 1.428 1.428h5.715A1.43 1.43 0 0025 12.143V6.429A1.43 1.43 0 0023.572 5zm-1.429 5.714h-2.857V7.857h2.857v2.857zM12.143 16.429H6.429A1.43 1.43 0 005 17.857v5.715C5 24.36 5.64 25 6.429 25h5.714a1.43 1.43 0 001.428-1.428v-5.715a1.43 1.43 0 00-1.428-1.428zm-1.429 5.714H7.857v-2.857h2.857v2.857z","fill":"#525F7F"}}),_c('path',{attrs:{"d":"M19.286 16.429h-2.857v2.857h2.857v-2.857zM22.143 19.286v2.857h-2.857V25h4.285A1.43 1.43 0 0025 23.57v-4.285h-2.857z","fill":"#B4BCCF"}})])
          )
        }
      }
    